export default () => {
    const tabs = document.querySelectorAll('.card-ambassador__points-tab') as NodeListOf<HTMLButtonElement>
    const tables = document.querySelectorAll('.history__table') as NodeListOf<HTMLElement>

    if (!tabs || !tables) return

    const toggleClass = (array, index) => {
        array.forEach(item => item.classList.remove('active'))
        array[index].classList.add('active')
    }

    tabs.forEach((tab, index) => {
        tab.onclick = () => {
            toggleClass(tabs, index)
            toggleClass(tables, index)
        }
    })
}
